// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerText":"Footer_footerText__n14sU","companyName":"Footer_companyName__YmZ5c"};